import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import Accordion from 'react-bootstrap/Accordion';

const SideFilter = (props) => {
    const [currentBrandFilter, setCurrentBrandFilter] = useState([]);
    const [currentColorFilter, setCurrentColorFilter] = useState([]);
    const [currentPriceFilter, setCurrentPriceFilter] = useState([]);

    var priceRanges = [];

    const updateBrandFilter = (value) => {
        var newList = currentBrandFilter;

        if(value.target.checked) {
            // add to list
            newList.push(value.target.id);
            setCurrentBrandFilter(newList);
        } else {
            // remove from list
            let index = newList.indexOf(value.target.id);
            if(index != -1) {
                newList.splice(index, 1); // remove 1 element from index 
            }       
        }

        console.log(value.target.id, value.target.checked);
        props.updateBrandFilter(newList);
    }

    const updateColorFilter = (value) => {
        var newList = currentColorFilter;

        if(value.target.checked) {
            // add to list
            newList.push(value.target.id);
            setCurrentColorFilter(newList);
        } else {
            // remove from list
            let index = newList.indexOf(value.target.id);
            if(index != -1) {
                newList.splice(index, 1); // remove 1 element from index 
            }       
        }

        console.log(value.target.id, value.target.checked);
        props.updateColorFilter(newList);
    }

    const updatePriceRange = (value, idx) => {
        console.log("PRICE RANGE CHANGE", value, idx);
        var newList = currentPriceFilter;

        if(value.target.checked) {
            // add to list
            newList.push(priceRanges[idx]);
            setCurrentPriceFilter(newList);
        } else {
            // remove from list
            var index = -1;
            for(var i=0; i<newList.length; i++) {
                if(newList[i].idx === idx) {
                    index = i;
                    break;
                }
            }
            if(index != -1) {
                newList.splice(index, 1); // remove 1 element from index 
            }       
        }

        props.updatePriceRange(newList);
    }

    if(props.prices && props.prices.length > 0) {
        var minPrice = props.prices[0][0].minPrice;
        var maxPrice = props.prices[0][0].maxPrice;
        var diff = maxPrice - minPrice;
        var stepSize = 10;
        var steps = Math.floor(diff / stepSize) +2;
        if(steps > 8) {
            stepSize = 20;
            steps = Math.floor(diff / stepSize) +2;
        }
        var currPrice = Math.ceil((minPrice)/10)*10 - stepSize;
        for(var i=0; i<steps; i++) {
            var nextPrice = 0;
                nextPrice = currPrice + stepSize - .01;
                priceRanges.push({idx: i, minPrice: currPrice, maxPrice: nextPrice});
            currPrice = nextPrice + .01;
        }
    }
    return (
        <div id="sideBarFilter" className="container">
            <h4>Brand</h4>
            {props.brands && props.brands.map(brand => (
                <Form.Check
                id={`${brand.maker}`}
                type="checkbox"
                label={`${brand.maker}`}
                onChange={updateBrandFilter}
              />
            ))}
            <h4>Prices</h4>
            {priceRanges && priceRanges.map((priceRange, index) => (
                <Form.Check
                id={`${priceRange.minPrice} - ${priceRange.maxPrice}`}
                type="checkbox"
                label={`$${priceRange.minPrice.toLocaleString(undefined, {maximumFractionDigits:2, minimumFractionDigits:2})} - $${priceRange.maxPrice.toLocaleString(undefined, {maximumFractionDigits:2, minimumFractionDigits:2})}`}
                onChange={(value) => {updatePriceRange(value, index);}}
              />
            ))}
            <h4>Colors</h4>
            {props.colors && props.colors.map((color, index) => (
                <Form.Check
                id={`${color.category != null ? color.category : "other"}`}
                type="checkbox"
                label={`${color.category != null ? color.category : "other"}`}
                onChange={updateColorFilter}
              />
            ))}
        </div>
    );
};
export default SideFilter;